import { tap, switchMap, groupBy, mergeMap } from "rxjs/operators";
import { Observable } from "rxjs";
import { formOperation } from "../../wrappers/formOperation";
import { TActionsDefinitionsList } from "./TAction";
import { action } from "./actionFunctions";
import { TEmailTemplateForm } from "../../../../domain/codecs/form/EmailTemplatesForm";

// Deliberately NOT autosaved, unlike the lenders tab: a debounced save would make a
// half-rewritten letter the live copy that every case handler sends in the meantime.
export const actions: TActionsDefinitionsList = [
    action("CRM_EMAIL_TEMPLATE_CHANGE", (obs$: Observable<TEmailTemplateForm>, lens, set) => {
        obs$.pipe(
            tap((form) => set(lens.email_templates_form.children.email_template_forms.where(({edited}) =>
                edited.id === form.edited.id
            ).set({ ...form, status: "requiresSubmission" }))),
        ).subscribe();
    }),
    action("CRM_EMAIL_TEMPLATE_SAVE", (obs$: Observable<TEmailTemplateForm>, lens, set) => {
        obs$.pipe(
            tap((form) => set(lens.email_templates_form.children.email_template_forms.where(({edited}) =>
                edited.id === form.edited.id
            ).status.set("submitting"))),
            // Per template, so saving one row cannot cancel another's in-flight request.
            groupBy((form) => form.edited.id),
            mergeMap((group$) => group$.pipe(
                switchMap((form) => formOperation("UpdateEmailTemplate", form)),
                tap((response) => set(lens.email_templates_form.children.email_template_forms.where(({edited}) =>
                    edited.id === response.edited.id
                ).set(response))),
            )),
        ).subscribe();
    }),
];
